// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__AL8yg","buttons":"Footer_buttons__2rWFZ"};